var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.187 0H.813A.817.817 0 000 .813v11.374A.817.817 0 00.813 13h11.374a.817.817 0 00.813-.813V.813A.817.817 0 0012.187 0zM2.032 3.251h1.219V2.032a.406.406 0 11.812 0v1.219h1.218a.408.408 0 110 .812H4.063v1.218a.408.408 0 01-.617.373.408.408 0 01-.195-.373V4.063H2.032a.407.407 0 110-.812zm10.155 8.53a.408.408 0 01-.406.406H1.216a.406.406 0 01-.405-.406L11.781.813a.408.408 0 01.406.406v10.562z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.966 7.8H6.5a.433.433 0 000 .867h3.466a.434.434 0 100-.867z"
  })));
}
export default SvgContrast;